import React, { useEffect, useState } from 'react';
import { Modal, Input, Icon, message, Button, Spin, Radio, Popconfirm } from "antd";
import Masonry from "react-masonry-component";
import 'moment/locale/zh-cn';
import { setToCover, updateCollNameAndDescription, inspiration_es_batchDelColl, inspiration_es_batchDelIns, fetchCollDetail } from '../../../../api/inspiration';
import { SimpleImg } from 'react-simple-img';
import { imgSuffix } from '../../../../util/inspiration';
import './index.less';

const masonryOptions = {
    transitionDuration: 0,
};
const imagesLoadedOptions = { background: ".my-bg-image-el" };

export default React.memo(function CheckModal(props) {
    const { modalVisible, onCancel, onOk, collId } = props;
    const [isLoading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [detailList, setDetailList] = useState([]);
    const [collName, setCollName] = useState('');
    const [description, setDescription] = useState('');
    const [collInfo, setCollInfo] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [editVisible, setEditVisible] = useState(false);
    const [isAllSelected, setAllSelected] = useState(false);

    useEffect(() => {
        if (collId && modalVisible) {
            setDetailList([]);
            setCollInfo(null);
            getImgList();
        }
    }, [collId, modalVisible]);

    useEffect(() => {
        if (editVisible) {
            setCollName(collInfo?.collName ?? '');
            setDescription(collInfo?.description ?? '');
        }
    }, [editVisible]);

    useEffect(() => {
        if (selectedIds.length != 0 && detailList.length != 0 && selectedIds.length == detailList.length && !isAllSelected) {
            setAllSelected(true);
        } else if ((selectedIds.length != detailList.length || selectedIds.length == 0 || detailList.length == 0) && isAllSelected) {
            setAllSelected(false);
        }
    }, [selectedIds]);

    const getImgList = async () => {
      setDetailList([]);
      setLoading(true);
      const res = await fetchCollDetail({collId});
      if (res?.error?.code == 0 && res?.data) {
          setCollInfo({
              collName: res.data?.collName ?? '',
              description: res.data?.description ?? ''
          });
          setDetailList(res.data?.insList ?? []);
      }
      setLoading(false);
    };
    
    const onImgClick = v => {
        let index = selectedIds.indexOf(v.insId);
        if (index != -1) {
            selectedIds.splice(index, 1);
            setSelectedIds([...selectedIds]);
        } else {
            setSelectedIds([...selectedIds, v.insId]);
        }
    };

    const edit = () => {
        setEditVisible(true);
    };

    // 编辑图集名称和描述
    const editCollInfo = async () => {
      if (!collName.trim()) {
        message.error('图集标题不能为空');
        return;
      }

      setConfirmLoading(true);
      const res = await updateCollNameAndDescription({
        collName,
        description,
        collId
      });

      if (res?.error?.code == 0 && res.data) {
        message.success('设置成功');
        setEditVisible(false);
        getImgList();
      } else if (res?.error?.code != 0 && res?.error?.message) {
        message.error(res.error.message);
      } else {
        message.error('设置失败');
      }
      setConfirmLoading(false);
    }

    const setCover = async (e, item) => {
      e.stopPropagation();
      const res = await setToCover({
        coverInsId: item.insId,
        collId
      });

      if (res?.error?.code == 0 && res.data) {
        message.success('设置成功');
        getImgList();
      } else if (res?.error?.code != 0 && res?.error?.message) {
        message.error(res.error.message);
      } else {
        message.error('设置失败');
      }
    };

    const del_collIds = async () => {
        message.loading("删除中...", 0);
        await inspiration_es_batchDelColl([collId])
          .then((res) => {
            if (res.data.error.code === 0) {
              message.destroy();
              success(res.data.data)
            } else {
              message.error(res.data.data);
            }
          })
          .catch(() => {
            message.destroy();
            message.error("数据格式错误");
          });
        onOk();
    };
    
    const del_insIds = async () => {
        message.loading("删除中...", 0);
        await inspiration_es_batchDelIns(selectedIds)
          .then((res) => {
            if (res.data.error.code === 0) {
              message.destroy();
              success(res.data.data);
            } else {
              message.error(res.data.data);
            }
          })
          .catch(() => {
            message.destroy();
            message.error("数据格式错误");
          });
        onOk();
    };

    const success = (data) => {
        Modal.success({
          content: '处理完毕!'
            // data.length > 0
            //   ? "处理完毕!其中未处理的id:\r\n" + data
            //   : "全部处理完毕!",
        });
    };

    return (
        <Modal
          width={1460}
          centered={true}
          visible={modalVisible}
          wrapClassName={'atlas_modal_wrap'}
          footer={
            <div>
              <Button type="primary" onClick={del_insIds}>
                删除图片
              </Button>
              <Button type="primary" onClick={del_collIds}>删除图集</Button>
            </div>
          }
          onCancel={onCancel}
        >
          <Spin spinning={isLoading}>
            <div className='header'>
                <span>标题:</span>
                <span style={{ maxWidth: 300, marginLeft: 10 }}>{collInfo?.collName ?? '暂无'}</span>
                <span style={{marginLeft: 30 }}>描述:</span>
                <span style={{ maxWidth: 300, marginLeft: 10 }}>{collInfo?.description ?? '暂无'}</span>
                <Button style={{ marginLeft: 30 }} onClick={edit}>编辑</Button>
            </div>
            <Masonry
              elementType={"ul"}
              options={masonryOptions}
              disableImagesLoaded={false}
              updateOnEachImageLoad={false}
              imagesLoadedOptions={imagesLoadedOptions}
            >
              {detailList && detailList.length ?
                detailList.map((item, index) => {
                  const height = Math.floor((250 * item.height) / item.width);
                  return (
                    <li
                      key={index}
                      className="atlasManager_iamgeItem"
                      onClick={() => onImgClick(item)}
                    >
                      <SimpleImg className='waterFall_item_img_wrap' height={height} src={(item.cover || item.img) + imgSuffix(250, height)} />
                      <div className={`mask ${ selectedIds.includes(item.insId) && 'mask_show'}`}>
                        <div className='triangle' />
                        <Icon type='check' className='check' />
                      </div>
                      <div className='setCover' onClick={e => e.stopPropagation()} >
                        <Popconfirm
                          title="是否确定将该图片设为封面？"
                          onConfirm={e => setCover(e, item)}
                          onCancel={e => e.stopPropagation()}
                          okText="确定"
                          cancelText="取消"
                        >
                          <Radio checked={item.coverFlag}>设为封面</Radio>
                        </Popconfirm>
                      </div>
                    </li>
                  );
                }) : <span>无搜索结果</span>}
            </Masonry>
          </Spin>
            <Modal
                title="提示"
                visible={editVisible}
                onOk={editCollInfo}
                confirmLoading={confirmLoading}
                onCancel={() => setEditVisible(false)}
                maskClosable={false}
                okText='确认'
                cancelText='取消'
                >
                <div>
                    <span style={{ width: 60 }}>标题:</span>
                    <Input
                        placeholder="请输入"
                        style={{ width: 200, marginLeft: 10 }}
                        value={collName}
                        onChange={e => setCollName(e.target.value)}
                    />
                    <br />
                    <br />
                    <span style={{ width: 60 }}>描述:</span>
                    <Input
                        placeholder="请输入"
                        style={{ width: 200, marginLeft: 10 }}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </div>
            </Modal>
        </Modal>
    )
})